if ("OTPCredential" in window) {
	window.addEventListener("DOMContentLoaded", (e) => {
		const input = document.querySelector('input[autocomplete="one-time-code"]');
		if (!input) {
			return;
		}
		const ac = new AbortController();
		const form = input.closest("form");
		if (form) {
			form.addEventListener("submit", (e) => {
				ac.abort();
			});
		}
		// Invoke the Web OTP API
		navigator.credentials
			.get({
				otp: { transport: ["sms"] },
				signal: ac.signal,
			})
			.then((otp) => {
				input.value = otp.code;
				// Automatically submit the form when an OTP is obtained.
				if (form) form.submit();
			})
			.catch((err) => {
				console.log(err);
			});
	});
}
